import React, { ReactElement, useState } from "react";
import { Drawer } from "antd";
import { DrawerStyles } from "antd/es/drawer/DrawerPanel";

type CustomDrawerProps = {
  component: React.ElementType; // Allows passing any component to render inside Drawer
  componentProps?: any; // Props for the dynamic component inside the Drawer
  title?: string; // Optional drawer title
  size?: "default" | "large"; // Drawer size
  trigger: ReactElement; // The dynamic trigger component
  width?: number;
  placement?: string;
};

const drawerStyles: DrawerStyles = {
  mask: {
    transition: "opacity 0.3s ease-in-out",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)", // Safari support
    background: "rgba(0, 0, 0, 0.3)", // Required for blur visibility
  },
  content: {
    transition: "transform 0.3s ease-in-out",
  },
};

const CustomDrawer: React.FC<CustomDrawerProps> = ({
  component: Component,
  componentProps,
  title,
  size,
  placement = "right",
  width,
  trigger, // Dynamic trigger component
}) => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  // Clone the trigger element and add the `onClick` event to open the drawer
  const TriggerComponent = React.cloneElement(trigger, { onClick: showDrawer });

  return (
    <>
      {TriggerComponent} {/* Trigger to open the Drawer */}
      <Drawer
        height="100%"
        maskClosable={false}
        placement={placement as any}
        width={size === "default" ? 378 : size === "large" ? 620 : width}
        size={size}
        title={title || null}
        onClose={closeDrawer}
        open={open}
        styles={drawerStyles}
        destroyOnClose
        footer={null} // No footer
      >
        {/* Render passed component with onCloseDrawer method */}
        <Component {...componentProps} onCloseDrawer={closeDrawer} />
      </Drawer>
    </>
  );
};

export default CustomDrawer;
